import React, { useCallback, useState } from 'react';
import classnames from 'classnames';
import axios from 'axios';

// TODO: emailJs
// import { SendForm } from 'api/forms';

import FormElem from './components/FormElem';
import Success from './components/Success';

import useOptions from 'hooks/graphql/useOptions';
import personPipedrive from 'helpers/personPipedrive';

import * as styles from './subscribeFormFull.module.scss';

const SubscribeFormFull = ({ fileUrl, articleTitle, pageUrl }) => {
  const [seccess, setSuccess] = useState(false);
  const [sendEmail, setSendEmail] = useState(false);
  const options = useOptions();

  const { subscribeFormFull } = options.subscribeFormFull;
  const { subscribeFormFullSuccessState } = subscribeFormFull;

  // TODO: open file in new tab
  const downloadFile = useCallback(() => {
    const fileToDownload = document.createElement('a');
    fileToDownload.href = fileUrl;
    fileToDownload.target = '_blank';
    document.body.appendChild(fileToDownload);
    fileToDownload.click();
    document.body.removeChild(fileToDownload);
  }, [fileUrl]);

  // TODO: API for google sheets data send
  const emailToGoogleSheet = useCallback(async (values) => {
    return await axios.post(
      'https://sheet.best/api/sheets/a7a4e65b-400f-4697-9d85-51da8c7f8cc4',
      values
    );
  }, []);

  //TODO: Create custom event
  const createGuideDownloadEvent = () => {
    try {
      typeof window !== 'undefined' &&
        window?.dataLayer &&
        window.dataLayer.push({ event: 'guide_download' });
    } catch (error) {
      console.info(error, 'custom event');
    }
  };

  const handleSubmit = async (values) => {
    setSendEmail(true);
    downloadFile();

    // TODO: emailJs
    // SendForm(values, 'subscribe_form_full');
    // console.info(values);

    createGuideDownloadEvent();

    try {
      await Promise.all([
        personPipedrive(values.email, articleTitle),
        emailToGoogleSheet(values),
      ]);

      setSuccess(true);
    } catch (error) {
      setSuccess(false);
    }
  };

  return (
    <div className={classnames(styles.container)}>
      {!seccess ? (
        <>
          <div className={classnames(styles.formWrap)}>
            <FormElem
              data={subscribeFormFull}
              articleTitle={articleTitle}
              pageUrl={pageUrl}
              onSubmit={(values) => handleSubmit(values)}
              seccessState={sendEmail}
            />
          </div>
        </>
      ) : (
        <Success data={subscribeFormFullSuccessState} />
      )}
    </div>
  );
};

export default SubscribeFormFull;
